import { StatPercent } from '@ui/components/Stats';
import { useMarketPrice } from '@ui/features/Trade/hooks/useMarketPrice';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { usePair24hAgoPrice } from '@ui/services/backend/hooks/oracle/usePair24hAgoPrice';
import { Flex, HStack } from 'styled-system/jsx';

export const Price24hDayStat = () => {
  const tradingPair = useTradingPair((s) => s.useTradingPair());
  const marketPrice = useMarketPrice();
  const change24h = usePair24hAgoPrice({
    pairBase: tradingPair.address,
    pythId: tradingPair.pythPriceFeedId,
    currentPrice: marketPrice ?? undefined,
  });

  // V2: 24h change renders as plain signed coloured mono text beside the
  // price — never a pill or tinted badge; no label on the desktop market bar
  return (
    <>
      <Flex direction="column" justifyContent="center">
        <HStack>
          <StatPercent
            fontSize="13px"
            value={change24h?.rate}
            opts={{ isShowSign: true }}
            data-cy="24H-PeakPriceRate"
            data-cy-value={change24h?.rate}
          />
        </HStack>
      </Flex>
    </>
  );
};
